import React, { useState } from 'react';
import { Modal, Button } from '@mui/material';
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router-dom';

function InactivityModal() {
  const [showModal, setShowModal] = useState(false);
  const history = useNavigate()

  useIdleTimer({
    timeout: 180000,
    onIdle: () => setShowModal(true),
    debounce: 500,
  });

  const handleOnActive = () => {
    setShowModal(false);
  };

  return (
    <div>
      <Modal open={showModal} onClose={handleOnActive}>
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#fff', padding: '20px' }}>
          <h2>Are you still here? You have been inactive for 3 minutes</h2>
          <Button onClick={handleOnActive} variant='contained'>Yes</Button>
          <Button onClick={()=>{history('/login')}} variant='contained' style={{background:'red'}} >No logout</Button>
        </div>
      </Modal>
    </div>
  );
}

export default InactivityModal;
